import { render, staticRenderFns } from "./YesNoChipCpt.vue?vue&type=template&id=262cb960&scoped=true&"
import script from "./YesNoChipCpt.vue?vue&type=script&lang=ts&"
export * from "./YesNoChipCpt.vue?vue&type=script&lang=ts&"
import style0 from "./YesNoChipCpt.vue?vue&type=style&index=0&id=262cb960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262cb960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
